import React from "react";
import {connect} from "react-redux";
import {checkIsDirty, setDirty} from '../../actions/common/commonActions';
import styles from "../../css/selectionTabs.less";
import {translate} from '../../i18n/translate.js';

class selectionTabs extends React.Component {
    static displayName = 'Tabs';

    static defaultProps = {
        selected: 0
    };

    constructor(props, context) {
        super(props, context);
        const children = props.children.filter(function (child) {
            return child && !child.props.invisible;
        });
        let selectedIndex;
        if(props.selectedTabTitle) {
            children.forEach(function (child, index) {
                if (child.props.label === props.selectedTabTitle) {
                    selectedIndex = index;
                }
            }.bind(this));
        }

        this.state = {
            selected: selectedIndex?selectedIndex:props.selected,
            children
        };
    }

    componentDidMount() {
        if(this.props.update !== undefined) {
            this.props.update(this.state.children[this.state.selected].props.label);
        }
    }

    componentWillReceiveProps(nextProps) {
        const children = nextProps.children.filter(function (child) {
            return child && !child.props.invisible;
        });
        this.setState({children});
    }

    _renderTitles = () => {
        function labels(child, index) {
            const activeClass = ("select-tab" + (this.state.selected === index ? ' active' : ''));
            return (
                <li key={index}>
                    <div
                       className={activeClass}
                       onClick={this.handleClick.bind(this, index)}>
                        {translate(child.props.label)}
                    </div>
                </li>
            );
        }
        return (
            <ul id="selectionTab" className="tabs__labels">
                {this.state.children.map(labels.bind(this))}
            </ul>
        );
    };

    _renderContent = () => {
        return (
            <div className="tabs__content">
                {this.state.children[this.state.selected]}
            </div>
        );
    };

    handleClick = (index, event) => {
        if(this.props.checkDirty) {
            this.props.checkIsDirty(function () {
                this.clickActions(index, event);
            }.bind(this));
        } else {
            this.clickActions(index, event);
        }
    };

    clickActions = (index, event) => {
        if (!this.props.disableCheckDirty) {
            this.props.setDirty(false);
        }
        event.preventDefault();
        this.setState({
            selected: index
        });
        if (this.props.update) {
            this.props.update(this.state.children[index].props.label);
        }
    };

    render() {
        let styleClass = this.props.styleClass?"tabs " + " " + this.props.styleClass:"tabs";
        return (
            <div className={styleClass}>
                {this._renderTitles()}
                {this._renderContent()}
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        checkIsDirty: onLeaveCallBack => {
            dispatch(checkIsDirty(onLeaveCallBack));
        },
        setDirty: isDirty => {
            dispatch(setDirty(isDirty));
        }
    }
};

export default connect(null, mapDispatchToProps)(selectionTabs);


// WEBPACK FOOTER //
// ./src/components/common/SelectionTabs.js